import types from '../types/summary'
import {Map} from 'immutable'
import startTypes from '../types/start'
import orchestratorTypes from '../types/orchestrator'

// TODO could probably delete this file

const initialRoot = Map({
  comment: '',
  isSaving: false,
  isConfirming: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case startTypes.GET_TRANSACTION_SUCCESS:
      return state.set('comment', action.payload.transaction.Comments)
    case types.SET_COMMENT:
      return state.set('comment', action.payload.value)
    case types.MODIFY_TRANSACTION:
      return state.merge({
        isSaving: true,
        error: '',
      })
    case types.MODIFY_TRANSACTION_SUCCESS:
      return state.merge({
        isSaving: false,
        error: '',
      })
    case types.MODIFY_TRANSACTION_FAIL:
      return state.merge({
        isSaving: false,
        error: action.payload.error,
      })
    case types.CONFIRM:
      return state.merge({
        isConfirming: true,
        error: '',
      })
    case types.CONFIRM_SUCCESS:
      return state.merge({
        isConfirming: false,
        error: '',
      })
    case types.CONFIRM_FAIL:
      return state.merge({
        isConfirming: false,
        error: action.payload.error,
      })
    case orchestratorTypes.START:
      return initialRoot
    default:
      return state
  }
}

export default root



// WEBPACK FOOTER //
// ./src/sections/remove/reducers/review.js